import Drawer from "~/components/Drawer/Drawer";
import Modifiers from "../Modifiers/Modifiers";
import { CartLineItem, OrderSource } from "~/entities/orderEntities";

import styles from "./SubModifiersDrawer.module.css";
import Button from "~/components/Button/Button";
import { useCallback, useEffect, useState } from "react";
import { cartIsValid } from "~/helpers/cartHelpers";
import { useMediaQuery } from "~/hooks/useMediaQuery";

type SubModifiersDrawerProps = {
  nav: string[][];
  setNav: (value: string[][]) => void;
  cart: CartLineItem;
  setCart: (cart: CartLineItem) => void;
  orderSource: OrderSource;
};

const SubModifiersDrawer: React.FC<SubModifiersDrawerProps> = ({
  nav,
  setNav,
  cart,
  setCart,
  orderSource,
}) => {
  const [showError, setShowError] = useState(false);
  const [closeNav, setCloseNav] = useState<string[][]>([[]]);

  const isMobile = useMediaQuery("(max-width: 768px)");

  const cartItemByNav = useCallback(
    (navItem: string[]): CartLineItem => {
      let curCartItem: CartLineItem | null = cart;
      navItem.forEach((childCartId) => {
        curCartItem =
          curCartItem?.children?.find((x) => x.id === childCartId) ?? null;
      });
      return curCartItem;
    },
    [cart]
  );

  const curViewingCart = cartItemByNav(nav[nav.length - 1]);

  const onApply = () => {
    if (cart && !cartIsValid(curViewingCart)) {
      setShowError(true);
    } else if (nav.length > 2) {
      setNav(nav.slice(0, nav.length - 1));
    } else {
      onClose();
    }
  };

  useEffect(() => {
    if (showError && cart && cartIsValid(curViewingCart)) {
      setShowError(false);
    }
  }, [cart, curViewingCart, showError]);

  const onClose = () => {
    setCloseNav(nav);
    setNav([nav[0]]);

    setTimeout(() => {
      setCloseNav([[]]);
    }, 500);
  };

  return (
    <Drawer
      drawerClassName={styles.drawer}
      contentClassName={styles.drawerContent}
      visible={isMobile && nav.length > 1}
      onClose={onClose}
      hideHeader
    >
      <Modifiers
        nav={nav.length > 1 ? nav : closeNav}
        setNav={setNav}
        cart={cart}
        setCart={setCart}
        showError={showError}
        orderSource={orderSource}
      />
      <div className={styles.buttons}>
        <Button onClick={onApply}>Apply</Button>
        <Button
          variant="secondary"
          onClick={() =>
            nav.length > 2 ? setNav(nav.slice(0, nav.length - 1)) : onClose()
          }
        >
          {nav.length > 2 ? "Back" : "Close"}
        </Button>
      </div>
    </Drawer>
  );
};

export default SubModifiersDrawer;
